// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3_7_b","col":"styles_col__1_m9k"};